/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TermsConsentStatus = {
  termsCode: TermsConsentStatus.termsCode;
  required: boolean;
  consent: boolean;
  consentDate: string;
};
export namespace TermsConsentStatus {
  export enum termsCode {
    DI = 'DI',
    SAFETY_SCORE = 'SAFETY_SCORE',
    UBI = 'UBI',
  }
}

